"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriorityContainer = exports.InputGrid = void 0;
const stitches_config_1 = require("../../../../../stitches.config");
exports.InputGrid = (0, stitches_config_1.styled)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    variants: {
        leftPadded: {
            true: {
                paddingLeft: "48px",
            },
        },
        row: {
            true: {
                flexDirection: "row",
                "> div": {
                    flexBasis: "50%",
                },
            },
        },
    },
});
exports.PriorityContainer = (0, stitches_config_1.styled)("div", {
    marginBottom: "8px",
    variants: {
        open: {
            true: {
                height: "300px",
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmxvb2RJbmZvTW9kYWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vY29tcG9uZW50cy9TZXR0aW5ncy9BY2NvdW50L1Byb3BlcnR5RGF0YS9fX3N0eWxlc19fL2Zsb29kSW5mb01vZGFscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxvRUFBd0Q7QUFFM0MsUUFBQSxTQUFTLEdBQUcsSUFBQSx3QkFBTSxFQUFDLEtBQUssRUFBRTtJQUNyQyxPQUFPLEVBQUUsTUFBTTtJQUNmLGFBQWEsRUFBRSxRQUFRO0lBQ3ZCLEdBQUcsRUFBRSxNQUFNO0lBRVgsUUFBUSxFQUFFO1FBQ1IsVUFBVSxFQUFFO1lBQ1YsSUFBSSxFQUFFO2dCQUNKLFdBQVcsRUFBRSxNQUFNO2FBQ3BCO1NBQ0Y7UUFDRCxHQUFHLEVBQUU7WUFDSCxJQUFJLEVBQUU7Z0JBQ0osYUFBYSxFQUFFLEtBQUs7Z0JBQ3BCLE9BQU8sRUFBRTtvQkFDUCxTQUFTLEVBQUUsS0FBSztpQkFDakI7YUFDRjtTQUNGO0tBQ0Y7Q0FDRixDQUFDLENBQUM7QUFFVSxRQUFBLGlCQUFpQixHQUFHLElBQUEsd0JBQU0sRUFBQyxLQUFLLEVBQUU7SUFDN0MsWUFBWSxFQUFFLEtBQUs7SUFDbkIsUUFBUSxFQUFFO1FBQ1IsSUFBSSxFQUFFO1lBQ0osSUFBSSxFQUFFO2dCQUNKLE1BQU0sRUFBRSxPQUFPO2FBQ2hCO1NBQ0Y7S0FDRjtDQUNGLENBQUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHN0eWxlZCB9IGZyb20gXCIuLi8uLi8uLi8uLi8uLi9zdGl0Y2hlcy5jb25maWdcIjtcblxuZXhwb3J0IGNvbnN0IElucHV0R3JpZCA9IHN0eWxlZChcImRpdlwiLCB7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICBnYXA6IFwiMTZweFwiLFxuXG4gIHZhcmlhbnRzOiB7XG4gICAgbGVmdFBhZGRlZDoge1xuICAgICAgdHJ1ZToge1xuICAgICAgICBwYWRkaW5nTGVmdDogXCI0OHB4XCIsXG4gICAgICB9LFxuICAgIH0sXG4gICAgcm93OiB7XG4gICAgICB0cnVlOiB7XG4gICAgICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgICAgIFwiPiBkaXZcIjoge1xuICAgICAgICAgIGZsZXhCYXNpczogXCI1MCVcIixcbiAgICAgICAgfSxcbiAgICAgIH0sXG4gICAgfSxcbiAgfSxcbn0pO1xuXG5leHBvcnQgY29uc3QgUHJpb3JpdHlDb250YWluZXIgPSBzdHlsZWQoXCJkaXZcIiwge1xuICBtYXJnaW5Cb3R0b206IFwiOHB4XCIsXG4gIHZhcmlhbnRzOiB7XG4gICAgb3Blbjoge1xuICAgICAgdHJ1ZToge1xuICAgICAgICBoZWlnaHQ6IFwiMzAwcHhcIixcbiAgICAgIH0sXG4gICAgfSxcbiAgfSxcbn0pO1xuIl19